import { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { isLoggedIn } from '../GlobalState';
import { Redirect } from 'react-router-dom';
import DashboardSampleImg from '../assets/dashboard-sample.png';

export const ModalDashboard = () => {
  const [loggedIn] = useRecoilState(isLoggedIn);
  const [windowDimensions, setWindowDimensions] = useState<any>(
    getWindowDimensions()
  );

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <img
        src={DashboardSampleImg}
        alt='dashboard'
        style={
          windowDimensions.width < 800
            ? { width: windowDimensions.width * 0.8, objectFit: 'contain' }
            : windowDimensions.width < 1285
            ? { width: windowDimensions.width * 0.9, objectFit: 'contain' }
            : { objectFit: 'contain' }
        }
      />
      <div style={{ height: 15, backgroundColor: '#f5f5f5' }} />
    </>
  );
};
